import no_intro1 from 'assets/sounds/no/rapidNaming/rapidNaming-intro1.mp3';
import no_intro2 from 'assets/sounds/no/rapidNaming/rapidNaming-intro2.mp3';
import no_intro3 from 'assets/sounds/no/rapidNaming/rapidNaming-intro3.mp3';
import no_intro4 from 'assets/sounds/no/rapidNaming/rapidNaming-intro4.mp3';
import no_intro5 from 'assets/sounds/no/rapidNaming/rapidNaming-intro5.mp3';

import nn_intro1 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro1.mp3';
import nn_intro2 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro2.mp3';
import nn_intro3 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro3.mp3';
import nn_intro4 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro4.mp3';
import nn_intro5 from 'assets/sounds/nn/rapidNaming/rapidNaming-intro5.mp3';

import gulteple from '../../assets/images/norming/rapidNaming/eple_gul-min.png';
import gronnkake from '../../assets/images/norming/rapidNaming/kake_green-min.png';
import rodstjerne from '../../assets/images/norming/rapidNaming/stjerne_red-min.png';
import brunteple from '../../assets/images/norming/rapidNaming/eple_brown-min.png';
import gulkake from '../../assets/images/norming/rapidNaming/kake_yellow-min.png';
import blastjerne from '../../assets/images/norming/rapidNaming/stjerne_blue-min.png';
import gronnsykkel from '../../assets/images/norming/rapidNaming/sykkel_gronn-min.png';
import brunkake from '../../assets/images/norming/rapidNaming/kake_brown-min.png';
import gulsykkel from '../../assets/images/norming/rapidNaming/sykkel_gul-min.png';
import gronnteple from '../../assets/images/norming/rapidNaming/eple_gronn-min.png';
import rodkake from '../../assets/images/norming/rapidNaming/kake_red-min.png';
import brunsykkel from '../../assets/images/norming/rapidNaming/sykkel_brown-min.png';
import blaeeple from '../../assets/images/norming/rapidNaming/eple_bla-min.png';
import rodmane from '../../assets/images/norming/rapidNaming/moon_red-min.png';
import blasykkel from '../../assets/images/norming/rapidNaming/sykkel-blue-min.png';
import gulstjerne from '../../assets/images/norming/rapidNaming/stjerne_gul-min.png';
import blamane from '../../assets/images/norming/rapidNaming/moon_blue-min.png';
import rodsykkel from '../../assets/images/norming/rapidNaming/sykkel_red-min.png';
import gronnstjerne from '../../assets/images/norming/rapidNaming/star_green-min.png';
import gulmane from '../../assets/images/norming/rapidNaming/moon_yellow-min.png';
import rodteple from '../../assets/images/norming/rapidNaming/eple_red-min.png';
import blakake from '../../assets/images/norming/rapidNaming/kake_blue-min.png';
import gronnmane from '../../assets/images/norming/rapidNaming/moon_green-min.png';

import brunmane from '../../assets/images/norming/rapidNaming/moon_brown-min.png';
import brunstjerne from '../../assets/images/norming/rapidNaming/stjerne_brown-min.png';

export const no = {
	intro1: no_intro1,
	intro2: no_intro2,
	intro3: no_intro3,
	intro4: no_intro4,
	intro5: no_intro5,
};

export const nn = {
	intro1: nn_intro1,
	intro2: nn_intro2,
	intro3: nn_intro3,
	intro4: nn_intro4,
	intro5: nn_intro5,
};

export const normingGrade234Images = {
	yellowApple: gulteple,
	greenCake: gronnkake,
	redStar: rodstjerne,
	brownApple: brunteple,
	yellowCake: gulkake,
	blueStar: blastjerne,
	greenBike: gronnsykkel,
	brownCake: brunkake,
	yellowBike: gulsykkel,
	greenApple: gronnteple,
	redCake: rodkake,
	brownBike: brunsykkel,
	blueApple: blaeeple,
	redMoon: rodmane,
	blueBike: blasykkel,
	yellowStar: gulstjerne,
	blueMane: blamane,
	brownStar: brunstjerne,
	redBike: rodsykkel,
	greenStar: gronnstjerne,
	yellowMoon: gulmane,
	redApple: rodteple,
	blueCake: blakake,
	brownMoon: brunmane,
	greenMoon: gronnmane,
};

export const normingGrade567YouthAdultImages = {
	blueBike: blasykkel,
	redApple: rodteple,
	greenMoon: gronnmane,
	brownCake: brunkake,
	yellowStar: gulstjerne,
	blueApple: blaeeple,
	greenBike: gronnsykkel,
	redStar: rodstjerne,
	brownMoon: brunmane,
	yellowCake: gulkake,
	greenApple: gronnteple,
	blueStar: blastjerne,
	redMoon: rodmane,
	brownBike: brunsykkel,
	yellowApple: gulteple,
	greenCake: gronnkake,
	blueMoon: blamane,
	redBike: rodsykkel,
	brownApple: brunteple,
	yellowMoon: gulmane,
	blueCake: blakake,
	greenStar: gronnstjerne,
	redCake: rodkake,
	yellowBike: gulsykkel,
	brownStar: brunstjerne,
	blueMoon2: blamane,
	greenApple2: gronnteple,
	yellowStar2: gulstjerne,
	redBike2: rodsykkel,
	brownCake2: brunkake,
	greenMoon2: gronnmane,
	blueBike2: blasykkel,
	yellowApple2: gulteple,
	redStar2: rodstjerne,
	brownMoon2: brunmane,
	blueCake2: blakake,
	greenBike2: gronnsykkel,
	yellowMoon2: gulmane,
	redApple2: rodteple,
	brownStar2: brunstjerne,
	greenCake2: gronnkake,
	blueStar2: blastjerne,
	yellowBike2: gulsykkel,
	redMoon2: rodmane,
	blueApple2: blaeeple,
	greenStar2: gronnstjerne,
	yellowCake2: gulkake,
	brownApple2: brunteple,
	redCake2: rodkake,
	brownBike2: brunsykkel,
};
